var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-text"},[_c('p',[_vm._v(_vm._s(_vm.$t( _vm.Value ? "GLOBAL_statusActive" : "GLOBAL_statusArchived" )))])])}
var staticRenderFns = []

export { render, staticRenderFns }